// extracted by mini-css-extract-plugin
export default {"appView":"App_appView__SbvlI","menu":"App_menu__aHEVs","routerView":"App_routerView__uk+3-"};